import Client from './client';

export default class ShopifyPromotions extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/promotions`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/promotions`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/promotions/${id}`, options);
  }

  putById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/promotions/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

}
